import { Component, ElementRef, EventEmitter, HostListener, OnInit, Output, ViewChild } from '@angular/core';
import { FilterService, FilterSettingsModel, GridModule, GroupService, PageService, PageSettingsModel, SelectionSettingsModel, SortService } from '@syncfusion/ej2-angular-grids'
import { DialogModule } from '@syncfusion/ej2-angular-popups';
import { TextBoxModule } from '@syncfusion/ej2-angular-inputs';
import { ToolbarService, LinkService, ImageService, HtmlEditorService, RichTextEditorModule, ToolbarSettingsModel, RichTextEditorComponent } from '@syncfusion/ej2-angular-richtexteditor';
import { AutoCompleteComponent, DropDownListModule, AutoCompleteModule } from '@syncfusion/ej2-angular-dropdowns';
import { FormsModule } from '@angular/forms';
import { ChipListModule } from '@syncfusion/ej2-angular-buttons'
import { formatDate, NgIf } from '@angular/common';
import { TicketService } from '../../services/ticket.service';
import { MessageStackService } from '../../services/message-stack.service';
import { LoaderComponent } from '../loader/loader.component';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Component({
  selector: 'app-help-desk',
  imports: [GridModule, LoaderComponent, DialogModule, TextBoxModule, RichTextEditorModule, DropDownListModule, FormsModule, AutoCompleteModule, ChipListModule, NgIf],
  providers: [PageService, SortService, FilterService, GroupService, ToolbarService, LinkService, ImageService, HtmlEditorService],
  templateUrl: './help-desk.component.html',
  styleUrl: './help-desk.component.css'
})
export class HelpDeskComponent implements OnInit {
  @Output() openTicketDetailsEvent = new EventEmitter<Object>()
  public filterOptions: FilterSettingsModel = { type: 'Excel' };
  public pageSettings: PageSettingsModel = { pageSizes: ['All', 5, 10, 20, 50], pageSize: 10 };
  public selectionOptions?: SelectionSettingsModel;
  public isLoading: boolean = true;
  public addNewTicket: boolean = false;
  public data: Object[] = [];
  public sortOptions: { text: string, value: string, category: string }[] = [
    { text: "Latest First", value: 'ticket_id-desc', category: 'Ticket ID' },
    { text: "Oldest First", value: 'ticket_id-asc', category: 'Ticket ID' },
    { text: "Latest First", value: 'last_updated-desc', category: 'Last Updated' },
    { text: "Oldest First", value: 'last_updated-asc', category: 'Last Updated' }
  ]
  dropdownWidth: string = '100px'
  selectedSortFilter = ''
  public statusData: { text: string; value: string }[] = [
    { text: "All", value: "All" },
    { text: "In-Progress", value: "In-Progress" },
    { text: "Answered", value: "Answered" },
    { text: "Resolved", value: "Resolved" },
    { text: "Reopen", value: "Reopen" },
    { text: "Closed", value: "Closed" },
    { text: "Parked", value: "Parked" },
    { text: "Unassigned", value: "Unassigned" }
  ]
  public issueData: { text: string; value: string }[] = [
    { text: 'General Inquiry', value: 'General Inquiry' },
    { text: 'Legal Issue', value: 'Legal Issue' },
    { text: 'Sales Issue', value: 'Sales Issue' },
    { text: 'Technical Issue', value: 'Technical Issue' }
  ]
  searchBoxText: string = ''
  ticketSubject: string = ''
  ticketMessage: string = ''
  participants: string = ''
  ticketIssue: string = ''
  selectedStatus: string = 'In-Progress'
  nextBtn: string = '';
  prevBtn: string = '';
  page: number = 1
  page_size: number = 25;
  userName: string = '';
  openLogoutPopup: boolean = false;
  isSubmitting: boolean = false;
  uploadedFilesArray: File[] = [];
  userEmail = ''
  ticketSubjectErrorMessage: string = '';
  participantsErrorMessage: string = '';
  ticketMessageErrorMessage: string = '';
  ticketNotAssigned: boolean = false;
  totalCountPerStatus: number = 0;
  searchTextError: boolean = false;
  ALLOWED_FILES: { [key: string]: string } = {
    jpg: "image/jpeg",
    jpeg: "image/jpeg",
    png: "image/png",
    gif: "image/gif",
    bmp: "image/bmp",
    tiff: "image/tiff",
    tif: "image/tiff",
    webp: "image/webp",
    svg: "image/svg+xml",
    ico: "image/x-icon",
    heic: "image/heic",
    heif: "image/heif",
    jfif: "image/jpeg",
    pjpeg: "image/pjpeg",
    pjp: "image/pjpeg",
    pdf: "application/pdf",
    doc: "application/msword",
    docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    xls: "application/vnd.ms-excel",
    xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    txt: "text/plain",
    csv: "text/csv",
    ppt: "application/vnd.ms-powerpoint",
    pptx: "application/vnd.openxmlformats-officedocument.presentationml.presentation",
    mp3: "audio/mpeg",
    wav: "audio/wav",
    ogg: "audio/ogg",
    aac: "audio/aac",
    flac: "audio/flac",
    m4a: "audio/mp4",
    mp4: "video/mp4",
    avi: "video/x-msvideo",
    mov: "video/quicktime",
    wmv: "video/x-ms-wmv",
    flv: "video/x-flv",
    mkv: "video/x-matroska",
    webm: "video/webm",
    zip: "application/zip",
    rar: "application/vnd.rar",
    "7z": "application/x-7z-compressed",
    tar: "application/x-tar",
    gz: "application/gzip",
  };
  rateLimitingError = false;
  noCustomerFound = false;
  showSortGrid: boolean = false;
  filter: string = '';
  order: string = '';
  public tools: ToolbarSettingsModel = {
    items: [
      'Bold', 'Italic', 'Underline', 'StrikeThrough', '|',
      'FontName', 'FontSize', 'FontColor', '|',
      'Alignments', 'OrderedList', 'UnorderedList', '|',
      'Indent', 'Outdent', '|',
      'CreateLink', 'Image', 'CreateTable', '|',
      'FullScreen'
    ], 
  };
  @ViewChild('autocomplete') autocomplete!: AutoCompleteComponent;
  @ViewChild('fileInput') fileInput: any;
  @ViewChild('rte') public rteObj!: RichTextEditorComponent;
  
  openTicketDetails() {
    this.addNewTicket = true
  }

  triggerFileInput() {
    this.fileInput.nativeElement.click();
  }

  onImageSelected(args: any): void {
    const file = args.filesData[0].rawFile;

    const authToken = sessionStorage.getItem('auth_token');
    if (!authToken) {
      console.error('Missing auth token');
      return;
    }

    const formData = new FormData();
    formData.append('files', file);

    const headers = new HttpHeaders({
      Authorization: `Bearer ${authToken}`
    });

    this.http.post<any>(
      'https://ticketingtool-dev.teamleaseregtech.com/api/inline_files_upload/',
      formData,
      { headers }
    ).subscribe({
      next: (res) => {
        console.log('Image upload response:', res);
        this.rteObj.focusIn();
        const uploadedUrl = res.files?.[0];
        if (uploadedUrl) {
          this.rteObj.executeCommand('insertImage', {
            url: uploadedUrl,
            width: {
              minWidth: '100px',
              maxWidth: '500px'
            },
            height: {
              minHeight: '100px',
              maxHeight: '500px'
            },
            altText: ''
          });
        } else {
          console.error('Upload succeeded but no image URL returned.');
        }
      },
      error: (err) => {
        console.error('Image upload failed:', err);
      }
    });
  }

  fileUploadErrorMessage: string = '';

  handleFileSelect(event: any) {
    this.fileUploadErrorMessage = '';

    const files = Array.from(event.target.files) as File[];
    const maxTotalSize = 25 * 1024 * 1024;

    const validFiles: File[] = [];
    const invalidFiles: string[] = [];

    for (const file of files) {
      const ext = file.name.split('.').pop()?.toLowerCase();
      const mime = file.type;

      if (ext && this.ALLOWED_FILES[ext] && this.ALLOWED_FILES[ext] === mime) {
        validFiles.push(file);
      } else {
        invalidFiles.push(file.name);
      }
    }

    if (invalidFiles.length > 0) {
      this.fileUploadErrorMessage = `You have uploaded an invalid file. Please check the file-extension of the \n${invalidFiles.join(', ')}.`;
      return;
    }

    const currentTotalSize = this.uploadedFilesArray.reduce((sum, file) => sum + file.size, 0);
    const newFilesTotalSize = validFiles.reduce((sum, file) => sum + file.size, 0);
    const combinedTotalSize = currentTotalSize + newFilesTotalSize;

    if (combinedTotalSize > maxTotalSize) {
      this.fileUploadErrorMessage = 'Total attachments size must not exceed 25 MB.';
      return;
    }

    this.uploadedFilesArray = [...this.uploadedFilesArray, ...validFiles];
    this.fileUploadErrorMessage = '';
  }


  removeFileFromUploadedArray(file: File) {
    this.uploadedFilesArray = this.uploadedFilesArray.filter(f => f !== file);

    const maxTotalSize = 20 * 1024 * 1024;
    const totalSize = this.uploadedFilesArray.reduce((sum, f) => sum + f.size, 0);

    if (totalSize > maxTotalSize) {
      this.fileUploadErrorMessage = 'Total attachments size must not exceed 25 MB.';
    } else {
      this.fileUploadErrorMessage = '';
    }
  }

  submitSearchForm() {
    this.searchTextError = false
    this.isLoading = true
    const searchTextLower = this.searchBoxText.toLowerCase();
    const validate = /^[a-zA-Z0-9_ ]+$/;
    if (validate.test(searchTextLower)) {
       this.ticketService.searchTicket(searchTextLower).subscribe({
      next: (response) => {
        this.isLoading = false
        this.prevBtn = response.previous
        this.nextBtn = response.next
        this.data = response.results
        this.page = 1

        this.data.forEach((ticket: any, index: number) => {
          ticket.updated_at = ticket.updated_at
            ? formatDate(ticket.updated_at, 'dd-MMM-YYYY, HH:mm', 'en-US')
            : '';
          ticket.created_at = ticket.created_at
            ? formatDate(ticket.created_at, 'dd-MMM-YYYY, HH:mm', 'en-US')
            : '';
        });

      },
      error: (err) => {
        this.data = []
        this.isLoading = false
        console.error(err)
      }
    })
  } else {
    this.searchTextError = true
    this.isLoading = false
  }
  }

  onPageSizeChangeSort(event: any) {
    this.page_size = event.target.value;
    this.ticketService.sortTicketsData(this.filter, this.order, this.page_size).subscribe({
      next: (response) => {
        this.isLoading = false
        this.totalCountPerStatus = response.count
        this.prevBtn = response.previous
        this.nextBtn = response.next
        this.data = response.results
        this.page = 1

         this.data.forEach((ticket: any, index: number) => {
          ticket.updated_at = ticket.updated_at
            ? formatDate(ticket.updated_at, 'dd-MMM-YYYY, HH:mm', 'en-US')
            : '';
          ticket.created_at = ticket.created_at
            ? formatDate(ticket.created_at, 'dd-MMM-YYYY, HH:mm', 'en-US')
            : '';
        });
      },
      error: (error) => {
        console.log(error)
      }
    })
  
  }

  onPageSizeChange(event: any) {
    this.page_size = event.target.value;
    this.ticketService.getTicketsData(this.selectedStatus, this.page_size).subscribe({
      next: (response) => {
        this.isLoading = false
        this.totalCountPerStatus = response.count
        this.prevBtn = response.previous
        this.nextBtn = response.next
        this.data = response.results
        this.page = 1

        this.data.forEach((ticket: any, index: number) => {
          ticket.updated_at = ticket.updated_at
            ? formatDate(ticket.updated_at, 'dd-MMM-YYYY, HH:mm', 'en-US')
            : '';
          ticket.created_at = ticket.created_at
            ? formatDate(ticket.created_at, 'dd-MMM-YYYY, HH:mm', 'en-US')
            : '';
        });

      },
      error: (error) => {
        this.data = []
        this.isLoading = false
        console.error(error)
      }
    })
  }

  clearSearchForm() {
    this.searchTextError = false
    this.searchBoxText = ''
    this.isLoading = true
    this.ticketService.getTicketsData(this.selectedStatus, this.page_size).subscribe({
      next: (response) => {
        this.isLoading = false
        this.totalCountPerStatus = response.count
        this.data = response.results
        this.nextBtn = response.next
        this.data = response.results
        this.page = 1

        this.data.forEach((ticket: any, index: number) => {
          ticket.updated_at = ticket.updated_at
            ? formatDate(ticket.updated_at, 'dd-MMM-YYYY, HH:mm', 'en-US')
            : '';
          ticket.created_at = ticket.created_at
            ? formatDate(ticket.created_at, 'dd-MMM-YYYY, HH:mm', 'en-US')
            : '';
        });


      },
      error: (error) => {
        this.data = []
        this.isLoading = false
        console.error(error)
      }
    })
  }

  closePopup() {
    this.addNewTicket = false;
  }

  submitTicketForm() {
    this.ticketSubjectErrorMessage = ''
    this.participantsErrorMessage = ''
    this.ticketMessageErrorMessage = ''
    this.rateLimitingError = false;
    this.noCustomerFound = false;


    const emailRegex = /^[a-zA-Z0-9._%+-]{1,64}@[a-zA-Z0-9.-]{1,255}\.[a-zA-Z]{2,24}$/;
    const participants: string[] = this.participants
      ? this.participants.split(';').map(email => email.trim()).filter(email => email)
      : [];
    const allEmailsValid = participants.length === 0 || participants.every(email => emailRegex.test(email));

    if (this.ticketSubject === '') {
      this.ticketSubjectErrorMessage = 'Please provide ticket subject.'
    } else if (!allEmailsValid) {
      this.participantsErrorMessage = 'Please provide valid emails separated by semicolons.'
    } else if (this.ticketMessage === '') {
      this.ticketMessageErrorMessage = 'Please provide ticket description.'
    }
    if (this.ticketSubjectErrorMessage === '' && this.participantsErrorMessage === '' && this.ticketMessageErrorMessage === '' && this.fileUploadErrorMessage === '') {
      this.addNewTicket = true
      this.isSubmitting = true
      this.ticketService.createTicket(this.ticketSubject, participants, this.ticketMessage, this.uploadedFilesArray).subscribe({
        next: (response) => {
          this.isSubmitting = false;
          if (response.results === 'Ticket created successfully.') {
            this.ticketSubject = ''
            this.ticketIssue = ''
            this.participants = ''
            this.ticketMessage = ''
            this.uploadedFilesArray = []
            this.addNewTicket = false
          } else {
            this.addNewTicket = true
          }
        },
        error: (error) => {
          this.isSubmitting = false;
          this.addNewTicket = true
          if (error.status === 429) {
            this.rateLimitingError = true;
          }
          console.log(error.status)
          if (error.status === 400 && error.error.results) {
            this.noCustomerFound = true;
          }
          console.error(error)
        }
      })
    }
  }

  statusChange(event: any) {
    // this.getTicketsCount(event)
    this.showSortGrid = false
    this.isLoading = true
    this.selectedStatus = event

    this.ticketService.getTicketsData(event, this.page_size).subscribe({
      next: (response) => {
        this.isLoading = false
        this.totalCountPerStatus = response.count
        this.data = response.results
        this.nextBtn = response.next
        this.prevBtn = response.previous
        this.page = 1

        this.data.forEach((ticket: any, index: number) => {
          ticket.updated_at = ticket.updated_at
            ? formatDate(ticket.updated_at, 'dd-MMM-YYYY, HH:mm', 'en-US')
            : '';
          ticket.created_at = ticket.created_at
            ? formatDate(ticket.created_at, 'dd-MMM-YYYY, HH:mm', 'en-US')
            : '';
        });

      },
      error: (error) => {
        this.data = []
        this.isLoading = false
        console.error(error)
      }
    })
  }

  sortData(event: any) {
    this.isLoading = true
    const [filter, order] = event.split('-')
    this.filter = filter
    this.order = order
    this.showSortGrid = true

    this.ticketService.sortTicketsData(filter, order, this.page_size).subscribe({
      next: (response) => {
        this.isLoading = false
        this.totalCountPerStatus = response.count
        this.prevBtn = response.previous
        this.nextBtn = response.next
        this.data = response.results
        this.page = 1

        this.data.forEach((ticket: any, index: number) => {
          ticket.updated_at = ticket.updated_at
            ? formatDate(ticket.updated_at, 'dd-MMM-YYYY, HH:mm', 'en-US')
            : '';
          ticket.created_at = ticket.created_at
            ? formatDate(ticket.created_at, 'dd-MMM-YYYY, HH:mm', 'en-US')
            : '';
        });

      },
      error: (error) => {
        this.data = []
        this.isLoading = false
        console.error(error);
      }
    })
  }

  getTicketDetails(ticket_id: string) {

    this.ticketNotAssigned = false

    const ticket: any = this.data.find((item: any) => {
      return item.ticket_id === ticket_id
    })

    this.ticketService.getTicketDetails(ticket_id).subscribe({
      next: (response) => {
        this.messageStackService.messageStack = response
        this.openTicketDetailsEvent.emit({ ...ticket, email_stack: response, cc_list: ticket.cc_list })
      },
      error: (error) => {
        if (error.error.results === `No ticket found with ID ${ticket_id}.`) {
          this.ticketNotAssigned = true
        }
      }
    })
  }

  prevPage(nextPageURI: string, status: string) {
    this.page = this.page - 1

    this.ticketService.nextTicketData(nextPageURI, status).subscribe({
      next: (response) => {
        this.nextBtn = response.next
        this.prevBtn = response.previous
        this.data = response.results

         this.data.forEach((ticket: any, index: number) => {
          ticket.updated_at = ticket.updated_at
            ? formatDate(ticket.updated_at, 'dd-MMM-YYYY, HH:mm', 'en-US')
            : '';
          ticket.created_at = ticket.created_at
            ? formatDate(ticket.created_at, 'dd-MMM-YYYY, HH:mm', 'en-US')
            : '';
        });
      }
    })

  }

  nextPageSort(nextPageURI: string,  filter: string, order: string) {
    this.page = this.page + 1

    this.ticketService.nextTicketDataSort(nextPageURI, filter, order).subscribe({
      next: (response) => {
        this.nextBtn = response.next
        this.prevBtn = response.previous
        this.data = response.results

         this.data.forEach((ticket: any, index: number) => {
          ticket.updated_at = ticket.updated_at
            ? formatDate(ticket.updated_at, 'dd-MMM-YYYY, HH:mm', 'en-US')
            : '';
          ticket.created_at = ticket.created_at
            ? formatDate(ticket.created_at, 'dd-MMM-YYYY, HH:mm', 'en-US')
            : '';
        });
      }
    })
  }

  prevPageSort(prevPageURI: string, filter: string, order: string) {
    this.page = this.page - 1

    this.ticketService.nextTicketDataSort(prevPageURI, filter, order).subscribe({
      next: (response) => {
        this.nextBtn = response.next
        this.prevBtn = response.previous
        this.data = response.results

         this.data.forEach((ticket: any, index: number) => {
          ticket.updated_at = ticket.updated_at
            ? formatDate(ticket.updated_at, 'dd-MMM-YYYY, HH:mm', 'en-US')
            : '';
          ticket.created_at = ticket.created_at
            ? formatDate(ticket.created_at, 'dd-MMM-YYYY, HH:mm', 'en-US')
            : '';
        });
      }
    })
  }

  nextPage(nextPageURI: string, status: string) {
    this.page = this.page + 1

    this.ticketService.nextTicketData(nextPageURI, status).subscribe({
      next: (response) => {
        this.nextBtn = response.next
        this.prevBtn = response.previous
        this.data = response.results

        this.data.forEach((ticket: any, index: number) => {
          ticket['sr_no'] = index + 1;
          ticket.updated_at = ticket.updated_at
            ? formatDate(ticket.updated_at, 'dd-MMM-YYYY, HH:mm', 'en-US')
            : '';
          ticket.created_at = ticket.created_at
            ? formatDate(ticket.created_at, 'dd-MMM-YYYY, HH:mm', 'en-US')
            : '';
        });
      }
    })

  }

  constructor(private readonly elementRef: ElementRef, private readonly ticketService: TicketService, private readonly messageStackService: MessageStackService, private http: HttpClient) { }

  ngOnInit(): void {
    this.isLoading = true
    this.userEmail = window.sessionStorage.getItem('emailAddress')!
    this.userName = window.sessionStorage.getItem('userName')!
    this.ticketService.getTicketsData(this.selectedStatus, this.page_size).subscribe({
      next: (response) => {
        this.isLoading = false
        this.totalCountPerStatus = response.count
        this.prevBtn = response.previous
        this.nextBtn = response.next
        this.data = response.results
        this.page = 1

        this.data.forEach((ticket: any, index: number) => {
          ticket.updated_at = ticket.updated_at
            ? formatDate(ticket.updated_at, 'dd-MMM-YYYY, HH:mm', 'en-US')
            : '';
          ticket.created_at = ticket.created_at
            ? formatDate(ticket.created_at, 'dd-MMM-YYYY, HH:mm', 'en-US')
            : '';
        });


      },
      error: (error) => {
        if (error.status === 404 && error.error.results === 'Customer user not found.') {
          this.noCustomerFound = true;
        }
        this.data = []
        this.isLoading = false
        console.error(error)
      }  
    })  
  }

  logout() {
    sessionStorage.clear();
    const currentDomain = window.location.hostname;


    if (currentDomain === 'helpdesk.teamleaseregtech.com') {
      window.location.href = 'https://login.teamleaseregtech.com/logout.aspx';
    } else if (currentDomain === 'helpdesk.avantisregtec.in') {
      window.location.href = 'https://uat.avantisregtec.in/logout.aspx';
    } else if (currentDomain === 'impl.teamleaseregtech.com') {
      window.location.href = 'https://impl.teamleaseregtech.com/logout.aspx';
    } else if (currentDomain === 'demohelpdesk.teamleaseregtech.com') {
      window.location.href = 'https://demo.teamleaseregtech.com/logout.aspx';
    }
  }

  openLogOutComponent() {
    this.openLogoutPopup = true
  }

  @HostListener('document:click', ['$event'])
  onClick(event: MouseEvent): void {
    const openLogoutPopup = this.elementRef.nativeElement.querySelector('.log-out-popup')

    if (openLogoutPopup && !openLogoutPopup.contains(event.target)) {
      this.openLogoutPopup = false
    }
  }
}
